import { Navigate, Outlet } from 'react-router-dom';
import { getToken } from '../../../utility/helper';

const UnProtectedRoute = () => {
    const token = getToken()

    if (token) {
        return <Navigate to="/dashboard" replace />;
    }

    return <Outlet />;  // Use Outlet instead of children
};

export default UnProtectedRoute;